import "@optionaldeps/jquery";

const _Select2 = typeof Select2 !== "undefined" ? Select2 : undefined;

export default _Select2;